export const CREATE_INTEGRATION = "CREATE_INTEGRATION"
export const CREATE_INTEGRATION_SUCCESS = "CREATE_INTEGRATION_SUCCESS"
export const CREATE_INTEGRATION_ERROR = "CREATE_INTEGRATION_ERROR"

export const GET_INTEGRATIONS = "GET_INTEGRATIONS"
export const GET_INTEGRATIONS_SUCCESS = "GET_INTEGRATIONS_SUCCESS"
export const GET_INTEGRATIONS_ERROR = "GET_INTEGRATIONS_ERROR"

export const GET_INTERMEDIATE_LEAD_INTEGRATIONS = "GET_INTERMEDIATE_LEAD_INTEGRATIONS"
export const GET_INTERMEDIATE_LEAD_INTEGRATIONS_SUCCESS = "GET_INTERMEDIATE_LEAD_INTEGRATIONS_SUCCESS"
export const GET_INTERMEDIATE_LEAD_INTEGRATIONS_ERROR = "GET_INTERMEDIATE_LEAD_INTEGRATIONS_ERROR"

export const UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS = "UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS"
export const UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS_SUCCESS = "UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS_SUCCESS"
export const UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS_ERROR = "UPDATE_INTERMEDIATE_LEAD_INTEGRATIONS_ERROR"

export const GET_INTEGRATION_TEMPLATES = "GET_INTEGRATION_TEMPLATES"
export const GET_INTEGRATION_TEMPLATES_SUCCESS = "GET_INTEGRATION_TEMPLATES_SUCCESS"
export const GET_INTEGRATION_TEMPLATES_ERROR = "GET_INTEGRATION_TEMPLATES_ERROR"

export const UPDATE_INTEGRATION = "UPDATE_INTEGRATION"
export const UPDATE_INTEGRATION_SUCCESS = "UPDATE_INTEGRATION_SUCCESS"
export const UPDATE_INTEGRATION_ERROR = "UPDATE_INTEGRATION_ERROR"

export const DUPLICATE_INTEGRATIONS = "DUPLICATE_INTEGRATIONS"
export const DUPLICATE_INTEGRATIONS_SUCCESS = "DUPLICATE_INTEGRATIONS_SUCCESS"
export const DUPLICATE_INTEGRATIONS_ERROR = "DUPLICATE_INTEGRATIONS_ERROR"

export const DELETE_INTEGRATION = "DELETE_INTEGRATION"
export const DELETE_INTEGRATION_SUCCESS = "DELETE_INTEGRATION_SUCCESS"
export const DELETE_INTEGRATION_ERROR = "DELETE_INTEGRATION_ERROR"

export const GET_RESPONSE_PARSER_FUNCTIONS = "GET_RESPONSE_PARSER_FUNCTIONS"
export const GET_RESPONSE_PARSER_FUNCTIONS_SUCCESS = "GET_RESPONSE_PARSER_FUNCTIONS_SUCCESS"
export const GET_RESPONSE_PARSER_FUNCTIONS_ERROR = "GET_RESPONSE_PARSER_FUNCTIONS_ERROR"

// GET SF LEAD INTEGRATION MACROS
export const GET_SF_LEAD_INTEGRATION_MACROS = "GET_SF_LEAD_INTEGRATION_MACROS"
export const GET_SF_LEAD_INTEGRATION_MACROS_SUCCESS = "GET_SF_LEAD_INTEGRATION_MACROS_SUCCESS"
export const GET_SF_LEAD_INTEGRATION_MACROS_ERROR = "GET_SF_LEAD_INTEGRATION_MACROS_ERROR"

//TEST INTEGRATION
export const TEST_INTEGRATION = "TEST_INTEGRATION"
export const TEST_INTEGRATION_SUCCESS = "TEST_INTEGRATION_SUCCESS"
export const TEST_INTEGRATION_ERROR = "TEST_INTEGRATION_ERROR"

export const GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE = "GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE"
export const GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE_SUCCESS = "GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE_SUCCESS"
export const GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE_ERROR = "GET_LEAD_INTEGRATION_DEFAULT_PAYLOAD_VALUE_ERROR"

export const GET_LEAD_INTEGRATION_LOGS_BY_ID="GET_LEAD_INTEGRATION_LOGS_BY_ID"
export const GET_LEAD_INTEGRATION_LOGS_BY_ID_SUCCESS="GET_LEAD_INTEGRATION_LOGS_BY_ID_SUCCESS"
export const GET_LEAD_INTEGRATION_LOGS_BY_ID_ERROR="GET_LEAD_INTEGRATION_LOGS_BY_ID_ERROR"

export const EXPORT_LEAD_INTEGRATION_LOGS = "EXPORT_LEAD_INTEGRATION_LOGS"
export const EXPORT_LEAD_INTEGRATION_LOGS_SUCCESS = "EXPORT_LEAD_INTEGRATION_LOGS_SUCCESS"
export const EXPORT_LEAD_INTEGRATION_LOGS_ERROR = "EXPORT_LEAD_INTEGRATION_LOGS_ERROR"

export const GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES = "GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES"
export const GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES_SUCCESS = "GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES_SUCCESS"
export const GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES_ERROR = "GET_SF_LEAD_INTEGRATION_MACRO_CATEGORIES_ERROR"

export const GET_CAMPAIGNS_BY_INTEGRATION = "GET_CAMPAIGNS_BY_INTEGRATION"
export const GET_CAMPAIGNS_BY_INTEGRATION_SUCCESS = "GET_CAMPAIGNS_BY_INTEGRATION_SUCCESS"
export const GET_CAMPAIGNS_BY_INTEGRATION_ERROR = "GET_CAMPAIGNS_BY_INTEGRATION_ERROR"

export const GET_INTEGRATIONS_STATS_BY_DATES = "GET_INTEGRATIONS_STATS_BY_DATES"
export const GET_INTEGRATIONS_STATS_BY_DATES_SUCCESS = "GET_INTEGRATIONS_STATS_BY_DATES_SUCCESS"
export const GET_INTEGRATIONS_STATS_BY_DATES_ERROR = "GET_INTEGRATIONS_STATS_BY_DATES_ERROR"

export const GET_INTEGRATIONS_FAILURE_REASON_STATS = "GET_INTEGRATIONS_FAILURE_REASON_STATS"
export const GET_INTEGRATIONS_FAILURE_REASON_STATS_SUCCESS = "GET_INTEGRATIONS_FAILURE_REASON_STATS_SUCCESS"
export const GET_INTEGRATIONS_FAILURE_REASON_STATS_ERROR = "GET_INTEGRATIONS_FAILURE_REASON_STATS_ERROR"

export const GET_INTEGRATIONS_STATS = "GET_INTEGRATIONS_STATS"
export const GET_INTEGRATIONS_STATS_SUCCESS = "GET_INTEGRATIONS_STATS_SUCCESS"
export const GET_INTEGRATIONS_STATS_ERROR = "GET_INTEGRATIONS_STATS_ERROR"

export const GET_INTEGRATION_SAMPLE_LEADS = "GET_INTEGRATION_SAMPLE_LEADS"
export const GET_INTEGRATION_SAMPLE_LEADS_SUCCESS = "GET_INTEGRATION_SAMPLE_LEADS_SUCCESS"
export const GET_INTEGRATION_SAMPLE_LEADS_ERROR = "GET_INTEGRATION_SAMPLE_LEADS_ERROR"
